<template>
  <div class="inner-page new-detail-page">
    <app-layout ovflowFlowMain="auto">
      <app-header slot="header">
        <header-right slot="right"></header-right>
      </app-header>
      <a-spin size="large" :spinning="isLoading">
      <div class="inner-page__main" slot="default">
        <div class="inner-page__main__bg new-detail--bg">
          <breadcrumb :navList="false"></breadcrumb>
          <div class="inner-page__content inner-page__content--new-detail">
            <div class="detail-left">
              <div class="detail-content" v-if="Object.keys(newDetail).length">
                <h6 class="title">{{newDetail.title}}</h6>
                <p class="time">{{newDetail.created}}</p>
                <div class="content" v-html="newDetail.content"></div>
              </div>
              <empty v-else/>
              <div class="button-wrap">
                <div class="button-left">
                  <div v-if="prevNew && Object.keys(prevNew).length">
                    <a-button type="link" class="custom-button" icon="left" @click="getNewDetail(prevNew.id)">上一篇</a-button>
                    <h6 class="title">{{prevNew.title}}</h6>
                  </div>
                </div>
                <div class="button-right">
                  <div v-if="nextNew && Object.keys(nextNew).length">
                    <a-button type="link" class="custom-button" icon="right" @click="getNewDetail(nextNew.id)">下一篇</a-button>
                    <h6 class="title">{{nextNew.title}}</h6>
                  </div>
                </div>
              </div>
            </div>
            <div class="detail-right">
              <div class="inner-page__content--header">
                    <div class="inner-page__content--title">
                      <span class="title">热门推荐</span>
                    </div>
                </div>
                <div class="popular-recommend" v-if="popularRecommend.length">
                  <div class="item" v-for="(item, index) in popularRecommend" :key="index">
                    <h6 class="title" @click="getNewDetail(item.id)">{{item.title}}</h6>
                    <p class="time">{{item.time}}</p>
                  </div>
                </div>
                <empty v-else />
            </div>
          </div>
		  <breadcrumb :navList="navList"></breadcrumb>
        </div>
      </div>
      </a-spin>
    </app-layout>
  </div>
</template>

<script>
import HeaderRight from '../components/layout/header-right.vue'
import Breadcrumb from '../components/breadcrumb/breadcrumb.vue'
import Empty from '../components/empty/empty.vue'
import { news } from '@/api'

export default {
  name: 'newDetail',
  components: { HeaderRight, Breadcrumb, Empty },
  data () {
    return {
      navList: [
        {
          text: '返回首页'
        },
        {
          text: '时政新闻',
          path: '/newsList'
        }
      ],
      newDetail: {},
      popularRecommend: [],
      prevNew: {},
      nextNew: {},
      currentId: '',
      isLoading: true
    }
  },
  created () {
    let { id } = this.$route.query || {}
    this.currentId = id
    Promise.all([this.getNewDetail(id), this.getPopularRecommend()]).then((res) => {
      let title = (res[0] || {}).title
      this.navList.push({
        text: title
      })
    }).catch(() => {
      this.$message.error('请求数据失败')
    }).finally(() => {
      this.isLoading = false
    })
  },
  methods: {
    getNewDetail (id) {
      this.isLoading = true
      return news.newDetail({ id }).then(res => {
        let { data: { current = {}, prev = [], next = [] }, status, msg = '' } = res || {}
        if (status !== 'success') {
          this.$message.error(msg)
          return res
        }
        this.newDetail = current
        this.prevNew = prev[0]
        this.nextNew = next[0]
        return current
      }).catch(() => {
        this.$message.error('请求数据失败')
      }).finally(() => {
        this.isLoading = false
      })
    },

    getPopularRecommend () {
      return news.hotNewsList().then(res => {
        let { data, status, msg = '' } = res || {}
        if (status !== 'success') {
          this.$message.error(msg)
          return res
        }
        this.popularRecommend = data
        return data
      })
    }
  }
}
</script>

<style lang="less" scoped>
  @import "../assets/style/index";
  .new-detail--bg{
    min-height: 874px;
  }
  .new-detail-page .inner-page__content--new-detail{
    padding: 30px 20px 68px 20px;
    display: flex;
    justify-content: space-between;
	background-color: @contentBgColor;
	
  }
  .detail-left{
    width: 982px;
    .detail-content{
      padding: 0 0 50px 0;
      border-bottom: 1px solid rgba(216, 216, 216, 0.1); /*no*/
      .title{
        font-size: 24px;
        color: @titleColor;
        margin-bottom: 20px;
      }
      .time{
        color: @dateColor;
        font-size: 12px;
        margin-bottom: 25px;
      }
      .content{
        padding-top: 47px;
        line-height: 26px;
        font-size: 16px;
        color: @textColor;
        text-indent: 32px;
        /deep/ img, p>img, p>a>img{
          max-width: 100%;
          display: block;
          margin: 0 auto;
        }
      }
    }
    .button-wrap{
      padding: 56px 0 0 0;
      display: flex;
      justify-content: space-between;
      .button-right,.button-left{
        width: 40%;
      }
      .custom-button{
        font-size: 16px;
        color: @titleColor;
        padding: 0;
      }
      .title{
        font-size: 14px;
        color: @dateColor;
        margin-top: 5px;
        .multiline-text-over(2);
      }
      .button-right{
        text-align: right;
        .custom-button{
          i{
            float: right;
          }
        }
      }
    }
  }
  .detail-right{
    width: 375px;
	.inner-page__content--header{
		.inner-page__content--title{
			.title{
				color: @titleColor;
			}
		}
	}
    .popular-recommend{
      padding: 10px 0 36px 0;
      .item{
        padding: 15px 0;
        border-bottom: 1px solid rgba(216, 216, 216, 0.1); /*no*/
        .title{
          margin: 0;
          font-size: 14px;
          color: @textColor;
          .multiline-text-over(2);
          &:hover{
            color: @titleColor;
            cursor: pointer;
            text-decoration: underline;
          }
        }
        .time{
          font-size: 12px;
          color: @dateColor;
          margin: 12px 0 0 0;
        }
      }
    }
  }
</style>
<style lang="less">
  .new-detail-page{
    .button-right{
      .custom-button{
        .anticon{
          float: right;
          line-height: 23px;
        }
        span{
          margin-right: 8px;
        }
      }
    }
  }
</style>